import { FC } from "react"
import { ButtonContained } from "shared/ui/buttons/buttonContained"
import { CheckboxList } from "shared/ui/checkbox"
import { Flex } from "shared/ui/flex"
import { TBox } from "widgets/allSlotsModal/types"
import { ButtonWrapper } from "../styles"

type AllSlotsModalFormProps = {
  checkboxes: TBox[];
  setActiveBoxes: (boxes: TBox[]) => void;
  defaultValues: TBox[];
  isBooking: boolean;
  isButtonDisabled?: boolean;
  onButtonClick?: () => void;
}

export const AllSlotsModalForm: FC<AllSlotsModalFormProps> = ({
  checkboxes,
  setActiveBoxes,
  defaultValues,
  isButtonDisabled = true,
  isBooking,
  onButtonClick = () => null,
}) => {

  const onChange = (checkbox: TBox[] | []) => {
    setActiveBoxes(checkbox)
  }

  return (
    <Flex $margin="0 0 16px 0" $padding="0 0 18px 0">
      <CheckboxList 
        checkboxes={checkboxes}
        multi
        changeCheckboxes={onChange}
        flexSetting={{direction: 'row', gap: '32px'}}
        defaultValue={defaultValues}
      />
      {isBooking && 
      <ButtonWrapper>
        <ButtonContained
          disabled={isButtonDisabled}
          isFullWidth
          padding="10.5px"
          onClick={onButtonClick}
        >
          Выбрать
        </ButtonContained>
      </ButtonWrapper>}
    </Flex>
  )
}